// extracted by mini-css-extract-plugin
export default {"cookieSettings":"N57m2uQu7GztdzuIKAno","cookieSettingsFooter":"fyFtbfJfFPMIV3oCGbJ9","cookieSettingsButtons":"PTFgqlsz7SXvkR9uD0Qe","sticky":"NuwZalDEhGaXO1ARFOfr"};